'use client';

import type { HeadingLevelOption, ThingsToKnowBlock } from './types';
import DescriptionBlock from './description-block';

type DescriptionListProps = {
	blocks: ThingsToKnowBlock[];
	headingLevel?: HeadingLevelOption;
};

export default function DescriptionList({ blocks, headingLevel }: DescriptionListProps) {
	const visibleBlocks = blocks.filter(block => block.body.length > 0 || block.title.length > 0);

	if (visibleBlocks.length === 0) return null;

	return (
		<div className="flex flex-col spacing-stack-l">
			{visibleBlocks.map(block => (
				<DescriptionBlock key={block.type} block={block} headingLevel={headingLevel} />
			))}
		</div>
	);
}
